import React from "react";
import { Fragment } from "react";
//import { LayoutClient } from "../layouts";

import Login from "../modules/Login/Login";
import Logout from "../modules/Login/Logout";
import Register from "../modules/Login/Register";
import SurveyPublicPage from "../modules/SurveyPublicPage"; // ← import trực tiếp, KHÔNG lazy (trang public load ngay)

/////////////admin/////////////////////////

const Dashboard = React.lazy(() => import("../modules/Dashboard/Dashboard"));
const Menu = React.lazy(() => import("../modules/Menu"));
const Module_Permission = React.lazy(() => import("../modules/Module_Permission"));
const Function_Permission = React.lazy(() => import("../modules/Function_Permission"));
const Role = React.lazy(() => import("../modules/Role"));
const Staff = React.lazy(() => import("../modules/Staff"));
const DiaryPersonal = React.lazy(() => import("../modules/DiaryPersonal"));
const User = React.lazy(() => import("../modules/User"));
const ReportAccount = React.lazy(() => import("../modules/ReportAccount"));
const Product = React.lazy(() => import("../modules/Product"));
const ProductCate = React.lazy(() => import("../modules/ProductCate"));
const AssetCategory = React.lazy(() => import("../modules/AssetCategory"));
const AssetDetails = React.lazy(() => import("../modules/AssetDetails"));
const AssetClassification = React.lazy(() => import("../modules/AssetClassification"));
const InventoryPlanning = React.lazy(() => import("../modules/InventoryPlanning"));
const InventoryExecution = React.lazy(() => import("../modules/InventoryExecution"));
const InventoryProcessing = React.lazy(() => import("../modules/InventoryProcessing"));
const DepreciationComputation = React.lazy(() => import("../modules/DepreciationComputation"));
const LocationManagement = React.lazy(() => import("../modules/LocationManagement"));
const TransferManagementController = React.lazy(() => import("../modules/TransferManagementController"));
const AssetSummaryReport = React.lazy(() => import("../modules/AssetSummaryReport"));
const CTR_TypeController = React.lazy(() => import("../modules/CTR_TypeController"));
const CTR_ContractController = React.lazy(() => import("../modules/CTR_ContractController"));
const SurveyBuilder = React.lazy(() => import("../modules/SurveyBuilder"));
const Department = React.lazy(() => import("../modules/Department"));
const Organize = React.lazy(() => import("../modules/Organize"));
const OrganizeInfo = React.lazy(() => import("../modules/OrganizeInfo"));
const CalendarWork = React.lazy(() => import("../modules/CalendarWork"));
const Surveystatistic = React.lazy(() => import("../modules/Surveystatistic"));
/////////////danh muc////
const CateNationality = React.lazy(() => import("../modules/CateNationality"));
const CateReligion = React.lazy(() => import("../modules/CateReligion"));
const CateOrganize = React.lazy(() => import("../modules/CateOrganize"));
const CateEthnic = React.lazy(() => import("../modules/CateEthnic"));
const CatePositionUnion = React.lazy(() => import("../modules/CatePositionUnion"));
const CatePositionParty = React.lazy(() => import("../modules/CatePositionParty"));
const CatePositionTradeUnion = React.lazy(() => import("../modules/CatePositionTradeUnion"));
const CateLanguageCertificate = React.lazy(() => import("../modules/CateLanguageCertificate"));
const CateInformaticsCertificate = React.lazy(() => import("../modules/CateInformaticsCertificate"));
const CateFormsTraining = React.lazy(() => import("../modules/CateFormsTraining"));
const CateLog = React.lazy(() => import("../modules/CateLog"));

// ─── Public routes: không cần đăng nhập, không có layout hệ thống ───────────
const publicRouters = [
    { path: "/login",    component: Login,            layout: Fragment },
    { path: "/s/:token", component: SurveyPublicPage, layout: Fragment }, // ← trang khảo sát public
];

// ─── Private routes: cần đăng nhập, dùng LayoutAdmin ────────────────────────
const privateRouters = [
    { path: "/", component: Dashboard },
    { path: "/register", component: Register },
    { path: "/logout", component: Logout },
    { path: "/role", component: Role },
    { path: "/staff", component: Staff },
    { path: "/diary_personal", component: DiaryPersonal },
    { path: "/user", component: User },
    { path: "/report_account", component: ReportAccount },
    { path: "/menu", component: Menu },
    { path: "/module_permission", component: Module_Permission },
    { path: "/function_permission", component: Function_Permission },
    { path: "/product", component: Product },
    { path: "/product_cate", component: ProductCate },
    { path: "/asst_category", component: AssetCategory },
    { path: "/asst_dt_details", component: AssetDetails },
    { path: "/asst_cl_classify", component: AssetClassification },
    { path: "/asst_pl_plan", component: InventoryPlanning },
    { path: "/asst_ex_execute", component: InventoryExecution },
    { path: "/asst_pr_process", component: InventoryProcessing },
    { path: "/asst_cm_compute", component: DepreciationComputation },
    { path: "/asst_lm_manage", component: LocationManagement },
    { path: "/asst_tm_handle", component: TransferManagementController },
    { path: "/asst_sm_summary", component: AssetSummaryReport },
    { path: "/ctr_type", component: CTR_TypeController },
    { path: "/ctr_contract", component: CTR_ContractController },
    { path: "/que_survey", component: SurveyBuilder },
    { path: "/que_sta", component: Surveystatistic },
    { path: "/department", component: Department },
    { path: "/organize", component: Organize },
    { path: "/organize_info", component: OrganizeInfo },
    { path: "/calendar_work", component: CalendarWork },
    { path: "/nationality_cate", component: CateNationality },
    { path: "/religion_cate", component: CateReligion },
    { path: "/organize_cate", component: CateOrganize },
    { path: "/ethnic_cate", component: CateEthnic },
    { path: "/position_union_cate", component: CatePositionUnion },
    { path: "/position_party_cate", component: CatePositionParty },
    { path: "/position_trade_union_cate", component: CatePositionTradeUnion },
    { path: "/language_certificate_cate", component: CateLanguageCertificate },
    { path: "/informatics_certificate_cate", component: CateInformaticsCertificate },
    { path: "/forms_training_cate", component: CateFormsTraining },
    { path: "/log_cate", component: CateLog },
];

export { publicRouters, privateRouters };